import { Link } from "react-router-dom";
import type { Drama } from "@/mocks/dramas";

export default function TopThree({ items }: { items: Drama[] }) {
  if (items.length === 0) return null;

  return (
    <section className="bg-background-100/60 py-16 md:py-20" aria-labelledby="top3-title">
      <div className="mx-auto max-w-page px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-label tracking-[0.3em] text-primary-400">本周榜单 · TOP 3</span>
            <h2 id="top3-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              综合口碑最高的三部黑料短剧
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
              综合剧情完成度、节奏紧凑度与读者反馈，选出本周最值得先看的三部作品，每一部都经得起二刷。
            </p>
          </div>
          <Link
            to="/ranking"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap text-sm font-label text-primary-400 transition-colors hover:text-primary-300 cursor-pointer"
          >
            查看完整榜单
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((drama, index) => (
            <article
              key={drama.id}
              className="group relative overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-colors hover:border-accent-500/70"
            >
              <Link to={`/drama/${drama.id}`} className="block cursor-pointer">
                <div className="relative w-full" style={{ aspectRatio: "16 / 11" }}>
                  <img
                    src={drama.cover}
                    alt={`${drama.title} 榜单封面`}
                    title={`${drama.title} 剧集封面`}
                    className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/30 to-transparent"></div>
                  <span className="absolute left-4 top-4 font-heading text-5xl font-black text-accent-500/90 drop-shadow">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <span className="absolute right-4 top-4 flex items-center gap-1 rounded-md bg-background-50/80 px-2.5 py-1 text-xs font-label text-accent-400 backdrop-blur">
                    <i className="ri-star-fill" aria-hidden="true"></i>
                    {drama.rating.toFixed(1)}
                  </span>
                </div>
              </Link>

              <div className="p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-950">
                  <Link to={`/drama/${drama.id}`} className="cursor-pointer transition-colors hover:text-primary-400">
                    {drama.title}
                  </Link>
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{drama.subtitle}</p>

                <div className="mt-4 flex flex-wrap items-center gap-2">
                  {drama.tags.slice(0, 3).map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-label text-accent-400"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                <div className="mt-4 flex items-center gap-3">
                  <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                    <div className="h-full rounded-full bg-primary-500" style={{ width: `${drama.heat}%` }}></div>
                  </div>
                  <span className="text-[11px] font-label text-foreground-500">热度 {drama.heat}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}